import { configureStore } from '@reduxjs/toolkit';
import filterSlice from '../features/filter/filterSlice';
import jobsSlice from '../features/jobs/jobsSlice';
import updateSlice from '../features/update/updateSlice';

export const store = configureStore({
  reducer: {
    jobs: jobsSlice,
    filter: filterSlice,
    update: updateSlice,
  },
});
